import React from 'react';


export const ToS = (
    <div className="block-of-text">
        <h2>Terms of use</h2>

        <h5 className="subheading">Use of this website is voluntary. </h5>
            <p>
                You ('user', 'users') may bring your own lunch to training sessions or
                ask a person managing lunch orders ('organisers') to buy some for you on the day instead.
            </p>
        <h5 className="subheading">Use of this software is completely at your own risk.</h5>
            <p>
                This is a beta release, meaning the software will have bugs and unforeseen problems
                that may compromise the security of any stored data. <br />
                Do not enter any confidential or irrecoverable data into the app.
            </p>
        <h5 className="subheading">This is not an ecommerce site.</h5>
            <p>
                This website is used for the purpose of helping organisers collect and record preferences and other
                information for lunch orders at training sessions.
            </p>
            <p>
                Use of this website does not create any sort of transaction between users, organisers or
                any other parties that may be involved. No goods or money can be exchanged through this website.
            </p>
            <p>
                Use of this website does not place any obligation, contractual or otherwise,
                on users, organisers or any other person, to provide or exchange goods, money, or services.
            </p>
            <p>
                <b>DO NOT ENTER ANY FINANCIAL INFORMATION INTO THIS WEBSITE</b><br />
                Do not enter any payment, banking or other personal financial information into this website.
                Do not enter addresses, phone numbers, licences/ID, or any other private information into this website.
            </p>

        <h5 className="subheading">Data policy</h5>
        <p>
            This website ('we', 'us' 'our') stores your name and lunch order information on our backend.
            This information is shared with organisers so they can help you with your lunch order.
        </p>
        <p>
            When you link a login service, you allow us to access information from the
            login service provider ('SSO') that uniquely identifies you to our backend.
            This information is used to authenticate you when logging in.
        </p>
        <p>
            When linking login services, please use SSO accounts that only you control and have access to.
        </p>
        <p>
            If you have any queries send a message on Discord.
        </p>
        <h5 className="subheading">Software Licence</h5>
        <p>This software is released under the MIT License</p>

        <p>
            Copyright (c) 2022 mintcarrotkeys
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy
            of this software and associated documentation files (the "Software"), to deal
            in the Software without restriction, including without limitation the rights
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software is
            furnished to do so, subject to the following conditions:
        </p>
        <p>
            The above copyright notice and this permission notice shall be included in all
            copies or substantial portions of the Software.
        </p>
        <p>
            <b>
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
            </b>
        </p>
        <p>
            Some graphic icons used in this app are sourced from Bootstrap Icons under the MIT licence.
            Copyright (c) 2011-2023 The Bootstrap Authors for those icons.
        </p>
        <p>
            The Generic Bells logo, which is used as a favicon (with a blue background), is:
            Copyright (c) 2022 mintcarrotkeys All rights reserved.
        </p>

    </div>
);